<script>
import { revenueTypes } from "@/store/types/types.js";
import MonthPicker from "@/components/MonthPicker";
import * as moment from "moment";
export default {
  name: "monthly-revenue",
  data() {
    return {
      month: new Date(),
      allDate: [],
      paymentList: [],
      stateDate: "",
      payAmount: 0,
      receiveNum: {
        small: 0,
        large: 0,
        smallCoupon: 0,
        largeCoupon: 0,
        smallCouponMonth: 0,
        largeCouponMonth: 0,
        rice: 0
      },
      receiveMoney: {
        small: 0,
        large: 0,
        smallCoupon: 0,
        largeCoupon: 0,
        smallCouponMonth: 0,
        largeCouponMonth: 0,
        rice: 0,
        defined: 0
      },
      receiveTotal: 0,
      focused: false
    };
  },
  components: {
    MonthPicker
  },
  computed: {
    detailList() {
      return this.$store.getters[revenueTypes.getters.getPaymentRevenueList];
    },
    receiveList() {
      return this.$store.getters[revenueTypes.getters.getReceiveRevenueList];
    }
  },
  methods: {
    getMonth(data) {
      //取得元件月份
      this.month = data;
      this.getChooseMonthArray();
    },
    expendPaymentDetail(index) {
      this.paymentList[index].state = !this.paymentList[index].state;
    },
    arrangepaymentList(year, month, endDayOfMonth) {
      //產生支出總列表以及顯示的所有日期
      let paymentList = [];
      const allDate = [];
      Array.from({ length: endDayOfMonth }, (item, index) => {
        //小於 10 號的日期補零
        let date = "";
        index + 1 < 10
          ? (date = `${year}-${month}-0${index + 1}`)
          : (date = `${year}-${month}-${index + 1}`);
        allDate.push(date);
        /**
         * 如果資料庫項目日期與計算日期相同，則放入該日項目陣列
         * paymentDetailList：當日的項目集合陣列
         */
        let paymentDetailList = [];
        this.detailList
          ? this.detailList.filter(paymentItem => {
              date === paymentItem.booked_at
                ? paymentDetailList.push(paymentItem)
                : null;
            })
          : null;
        // 塞入輸入欄預設資料
        let emptyPaymentItem = {
          amount: 0,
          detail: "",
          booked_at: date
        };
        paymentDetailList.push(emptyPaymentItem);
        // 如果沒有資料庫沒有資料，空資料就是預設資料。
        if (paymentDetailList.length === 0) {
          paymentDetailList = [emptyPaymentItem];
        }

        paymentList.push({
          date: date,
          state: false,
          amount: 0,
          detail: paymentDetailList
        });
      });
      this.paymentList = paymentList;
      this.allDate = allDate;
      this.calcPaymentAmount();
    },
    calcReceive() {
      if (this.receiveList) {
        this.receiveNum.small = this.receiveList["2～3人"];
        this.receiveNum.smallCoupon = this.receiveList["2～3人優惠"];
        this.receiveNum.smallCouponMonth = this.receiveList["2～3人優惠（月）"];
        this.receiveNum.large = this.receiveList["3～4人"];
        this.receiveNum.largeCoupon = this.receiveList["3～4人優惠"];
        this.receiveNum.largeCouponMonth = this.receiveList["3～4人優惠（月）"];
        this.receiveNum.rice = Number(this.receiveList["白飯"]);
        this.receiveMoney.defined = this.receiveList["自訂"];
        this.receiveMoney.small = this.receiveNum.small * 400;
        this.receiveMoney.smallCoupon = this.receiveNum.smallCoupon * 360;
        this.receiveMoney.smallCouponMonth = this.receiveNum.smallCouponMonth * 340;
        this.receiveMoney.large = this.receiveNum.large * 500;
        this.receiveMoney.largeCoupon = this.receiveNum.largeCoupon * 450;
        this.receiveMoney.largeCouponMonth = this.receiveNum.largeCouponMonth * 425;
        this.receiveMoney.rice = this.receiveNum.rice * 15;
        this.receiveTotal =
          this.receiveMoney.small +
          this.receiveMoney.smallCoupon +
          this.receiveMoney.smallCouponMonth +
          this.receiveMoney.large +
          this.receiveMoney.largeCoupon +
          this.receiveMoney.largeCouponMonth +
          this.receiveMoney.rice +
          this.receiveMoney.defined;
        return;
      }
      this.receiveTotal = 0;
    },
    getChooseMonthArray() {
      const year = moment(this.month).format("YYYY");
      const month = moment(this.month).format("MM");
      const endDayOfMonth = moment(this.month)
        .endOf("month")
        .format("DD");
      // 取得選擇月日以及當月最後一天
      this.$store
        .dispatch(revenueTypes.actions.QUERY_PAYMENT_REVENUE, {
          year: Number(year),
          month: Number(month)
        })
        .then(() => this.arrangepaymentList(year, month, endDayOfMonth));
      this.$store
        .dispatch(revenueTypes.actions.QUERY_RECEIVE_REVENUE, {
          year: Number(year),
          month: Number(month)
        })
        .then(() => this.calcReceive());
      //從 api 取得資料
    },
    deletePaymentItem(dayIndex, itemIndex) {
      let targetDetailList = this.paymentList[dayIndex].detail;
      this.$store.dispatch(
        revenueTypes.actions.DELETE_PAYMENT_REVENUE,
        targetDetailList[itemIndex].id
      );
      targetDetailList.splice(itemIndex, 1);
      this.calcPaymentAmount();
    },
    editPaymentItem(list, itemIndex) {
      this.$store
        .dispatch(revenueTypes.actions.EDIT_PAYMENT_REVENUE, list[itemIndex])
        .then(() => this.calcPaymentAmount());
    },
    checkPaymentMoney(dayIndex, itemIndex) {
      if (this.paymentList[dayIndex].detail.length === itemIndex + 1) {
        this.paymentList[dayIndex].detail[itemIndex].detail = "";
        this.paymentList[dayIndex].detail[itemIndex].amount = "";
      }
    },
    addPaymentItem(list, dayIndex, itemIndex, date) {
      let payment = list[itemIndex];
      if (payment.amount !== 0 && payment.detail !== "" && !payment.id) {
        this.$store
          .dispatch(revenueTypes.actions.ADD_PAYMENT_REVENUE, payment)
          .then(id => {
            this.paymentList[dayIndex].detail[itemIndex].id = id;
            this.calcPaymentAmount();
          });
        list.push({
          amount: 0,
          detail: "",
          booked_at: date
        });
        //都填入就增加資料且新增欄位
        return;
      }
      alert("金額、項目，兩者不得為空！");
      //如果金額跟項目其一未填入，則跳出警告
    },
    changePaymentItem(dayIndex, itemIndex, date) {
      let list = this.paymentList[dayIndex].detail;
      if (list[itemIndex].id >= 0) {
        this.editPaymentItem(list, itemIndex);
      } else {
        this.addPaymentItem(list, dayIndex, itemIndex, date);
      }
    },
    calcPaymentAmount() {
      // 計算當日總額
      let total = 0;
      this.paymentList.forEach(date => {
        let amount = 0;
        date.detail.length > 1
          ? date.detail.forEach(item => {
              amount = Number(item.amount) + amount;
            })
          : null;
        date.amount = amount;
        total = amount + total;
      });
      this.payAmount = total;
    }
  },
  mounted() {
    this.getChooseMonthArray();
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss" scoped />
